import { combineReducers } from 'redux';

import chargesandprepaymentsreport from './chargesandprepaymentsreport/reducer';

export default combineReducers({
  chargesandprepaymentsreport,
});



// WEBPACK FOOTER //
// ./src/pages/chargesandprepaymentsreport/state/reducer.js